import settings from '@/settings'

let buscarPropostasDoPosto = (headers, cnpj, filtros) => {
  let url = `${settings.apetrusApi}/proposta/buscarpropostasrecebidas/?posto=${cnpj}`
  if (filtros) {
    const keys = Object.keys(filtros)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${filtros[keys[i]] ? `&${keys[i]}=${filtros[keys[i]]}` : ''}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let submeterProposta = (data, headers) => {
  return fetch(`${settings.apetrusApi}/proposta/updatepropostaposto/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let confirmarValorProposta = (data, headers) => {
  return fetch(`${settings.apetrusApi}/proposta/atualizarvalorprosta/`, {
    method: 'PATCH',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let bucarRecargasPorPropostas = (data, headers) => {
  return fetch(`${settings.apetrusApi}/proposta/recargasporproposta/?empresa=${data.empresa}&proposta=${data.proposta}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let aprovarRecarga = (data, headers) => {
  return fetch(`${settings.apetrusApi}/proposta/recargarproposta/${data.id}/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let rejeitarProposta = (data, headers) => {
  return fetch(`${settings.apetrusApi}/proposta/${data.id}/rejeitar/`, {
    method: 'PATCH',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

export default {
  buscarPropostasDoPosto,
  submeterProposta,
  confirmarValorProposta,
  bucarRecargasPorPropostas,
  aprovarRecarga,
  rejeitarProposta
}
